import { type FC, useMemo } from 'react';

import { useSeriaPlusByLocation } from 'shared/settings/seriaPlusScheme';

import { SeriaPlusV2 } from './SeriaPlusV2';
import { tabs } from './internal/settings/seriaPlusScheme';
import { type SeriaPlusScheme } from './internal/settings/seriaPlusTypes';

export const BLOCK_ID = 'seria-plus-v2';

export const SeriaPlusV2Container: FC = () => {
  const seriaPlusByLocation = useSeriaPlusByLocation();
  const seriaPlusV2ByLocation = useMemo<SeriaPlusScheme | null>(
    () =>
      seriaPlusByLocation
        ? {
            description: seriaPlusByLocation.description,
            sectionTabTitle: seriaPlusByLocation.sectionTabTitle,
            tabs,
            title: seriaPlusByLocation.title,
            watchObjectsLink: seriaPlusByLocation.watchObjectsLink,
          }
        : null,
    [seriaPlusByLocation],
  );

  return seriaPlusV2ByLocation ? <SeriaPlusV2 id={BLOCK_ID} scheme={seriaPlusV2ByLocation} /> : null;
};
